import {useState} from 'react';


export default function useFlags() {

    const [ flags, setFlags ] = useState([]);

    function setFlagOn(key) {
        if(!flags.find(k => k === key)) {
            
            setFlags([...flags, key]);
        }
    }
    
    function setFlagOff(key) {
        setFlags(flags.filter(k => k !== key));
    }


    return [flags, setFlagOn, setFlagOff];
}